// Get API configuration from environment variables
const getApiConfig = () => {
  const isDevelopment = import.meta.env.MODE === 'development'
  const authApiUrl =
    import.meta.env.VITE_AUTH_API_URL ||
    (isDevelopment ? 'http://127.0.0.1:8080' : 'https://archon-backend.enter.de')

  return {
    baseUrl: isDevelopment ? '/user/v1/admin' : 'https://scout-service-v2.enter.de/user/v1/admin',
    authApiUrl,
    timeout: 30000,
  }
}

export const API_CONFIG = getApiConfig()
